export default __webpack_public_path__ + "static/media/bound-thumbnail.bae7200d.png";